module.exports = "\n<svg class=\"x-navbar-menu-icon\" width=\"17\" height=\"17\" viewBox=\"0 0 24 24\"\n     fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.5\"\n     stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\" focusable=\"false\">\n    <g v-html=\"paths\"></g>\n</svg>\n";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/javascript/components/ui/NavbarMenuIcon.vue
// module id = ./node_modules/vue-html-loader/index.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/javascript/components/ui/NavbarMenuIcon.vue
// module chunks = 54